{
    "TITLE": "Aplikacja zdalna",
    
        "SHARED": {
            "INTERNET_OFFLINE": "Twoje połączenie internetowe wydaje się w trybie offline.",
            "LANGUAGE": "Język",
            "NO_FEATURE": "Twoja licencja nie zawiera tej funkcji. Skontaktuj się z administratorem.",
            "FEATURE_UNAVAILABLE": "Twoja licencja nie zawiera tej funkcji.",
            "APP_UPDATE_NEEDED": "To use this feature, this participant needs to update their app.",
            "TRAINING_DISABLED": "Nie masz uprawnień do korzystania z tej funkcji. Proszę poprosić o pozwolenie od gospodarza."
        },
        "UPDATE_MODAL": {
            "TITLE": "Dostępna aktualizacja",
            "MESSAGE": "Nowa wersja dostępna. Ta strona zostanie ponownie załadowana po aktualizacji.",
            "UPDATE": "Przeładować",
            "UPDATE_FAILED": "Aktualizacja nieudana"
        },
        "LOGIN": {
        "SSO-BUTTON": "Zaloguj się przez SSO",
            "APP_NAME": "{{ appName }} Remote",
            "TITLE": "Zaloguj się do aplikacji zdalnej",
            "ACCOUNT_PLACEHOLDER": "Nazwa konta",
            "ACCOUNT_REQUIRED": "Wymagana nazwa konta.",
            "ACCOUNT_SHORT": "Nazwa konta musi wynosić co najmniej 2 znaki.",
            "USERNAME_PLACEHOLDER": "Nazwa użytkownika",
            "USERNAME_REQUIRED": "Nazwa użytkownika (wymagana",
            "USERNAME_SHORT": "Nazwa użytkownika musi mieć co najmniej 2 znaki.",
            "PASSWORD_PLACEHOLDER": "Hasło",
            "PASSWORD_REQUIRED": "wymagane hasło",
            "PASSWORD_SHORT": "Hasło musi mieć co najmniej 6 znaków.",
            "REMEMBER_ACCOUNT_NAME": "Zapamiętaj nazwę konta",
            "VERIFICATION_CODE": "Kod weryfikacyjny",
            "TWO_FACTOR_EMAIL_SENDED": "Wysłaliśmy Ci wiadomość e-mail z kodem weryfikacyjnym.",
            "VERIFY_BUTTON": "ZWERYFIKOWAĆ",
            "LOGIN_BUTTON": "ZALOGUJ SIE",
            "BACK_BUTTON": "POWRÓT",
            "BEFORE_TERMS": "Klikając login, zgadzasz się na nasz",
            "TERMS": "Warunki usługi",
            "CONJUNCTION": " oraz",
            "PRIVACY": "Polityka prywatności",
            "AFTER_PRIVACY": ".",
            "GUEST_DELETED": "Jesteś wylogowany.",
            "USER_DELETED": "Twoje konto zostało usunięte. Skontaktuj się z administratorem.",
            "USER_DISABLED": "Twoje konto zostało wyłączone. Skontaktuj się z administratorem.",
            "LOGGED_IN_ANOTHER_SESSION": "Jesteś zalogowany na inną sesję.",
            "LOGGED_OUT_UNKNOWN": "Coś poszło nie tak.",
            "NO_INTERNET_ERROR": "Brak internetu. Proszę sprawdzić swoje połączenie z internetem.",
            "USERNAME_PASSWORD_ERROR": "Nazwa konta, nazwa użytkownika lub hasło jest nieprawidłowe.",
            "ACCOUNT_DISABLED": "Twoje konto wygasło. Skontaktuj się z {{ contactMail }}",
            "INVALID_VERIFICATION_CODE": "Nieprawidłowy dwuetapowy kod weryfikacyjny.",
            "UNKNOWN_ERROR": "Wystąpił błąd podczas logowania.",
            "SIMULTANE_LOGIN_ERROR": "Jesteś zalogowany na inną sesję.",
            "USE_CHINA_SERVERS": "Zaloguję się z Chin",
            "CHINA_SERVERS_CAUTION": "Ta opcja może powodować opóźnienia poza Lądem Chin.",
            "MULTI_LOGIN_MODAL": {
                "TITLE": "Wielokrotne logowanie",
                "MESSAGE": "Twój użytkownik już się zalogował na innym urządzeniu. Jeśli będziesz kontynuowany, drugi użytkownik zostanie podpisany.",
                "CANCEL": "Zatrzymać",
                "PROCEED": "Przystępować"
            }
        },
        "MAIN": {
            "LICENSE_LEFT": "Masz {{ days }} Dni pozostawione w licencji zdalnej {{ appName }}.",
            "DEMO_LEFT": "Masz {{ days }} Dni pozostawione w wersji zdalnej { { appName }}.",
            "LEFT_BAR": {
                "LOBBY": "Lobby",
                "ROOMS": "Pokoje",
                "MEETINGS": "Spotkania",
                "FEEDBACK": "Informacja zwrotna",
                "CONTACTS": "Użytkownicy.",
                "SESSIONS": "Sesje",
                "TICKETS": "Zgłoszenia",
                "PRECALL_TEST": "Test wstępny",
                "WHATS_NEW": "Co nowego",
                "PROFILE": "Profil",
                "HELP_CENTER": "Centrum pomocy",
                "LOGOUT": "Wyloguj"
            },
            "CALL_MESSAGE": {
                "TITLE": "Połączenie przychodzące z <strong>{{ caller_name }}</strong>",
                "DENY": "Zaprzeczyć",
                "ACCEPT": "Zaakceptować"
            },
            "GET_EXPORT_MODAL": {
                "TITLE": "Eksport sesji.",
                "MESSAGE1": "Wprowadź swój adres e-mail, aby otrzymać link, aby pobrać eksport sesji po zakończeniu sesji.",
                "MESSAGE2": "Eksport sesji będzie zawierać wszystkie <strong> wiadomości czatu </ strong>, <strong> migawki <strong />, <strong> rekordy połączeń wideo </ strong> i <strong> pliki </ strong> współdzielone w sesji.",
                "EXPORT_NAME_NOT_LOCKED": "Możesz zmienić nazwę pliku eksportu, wprowadzając zamiast tego dostosowaną nazwę pliku.",
                "EXPORT_NAME_LOCKED": "Będziesz mógł zmienić nazwę pliku eksportu, gdy tylko inny użytkownik zakończy eksport.",
                "EXPORT_NAME_RENAMED": "Plik eksportu został zmieniony przez tego użytkownika:",
                "EXPORT_NAME_PLACEHOLDER": "Eksportuj nazwę",
                "NOTE": "Uwaga: Możesz zaktualizować swój adres e-mail z menu profilowego.",
                "NOTE2": "Uwaga: Możesz zaktualizować swój adres e-mail za pośrednictwem administratora.",
                "OPEN_PROFILE": "Otwórz profil",
                "EMAIL": "E-mail",
                "EMAIL_REQUIRED": "Email (wymagany",
                "EMAIL_INVALID": "niewłaściwy format wiadomości email",
                "CLOSE": "Anuluj",
                "SEND": "Wyślij",
                "EXPORT_SUCCEEDED": "Eksport sesji zostanie wysłany po zakończeniu sesji.",
                "ENDED_SESSION_EXPORT_SUCCEEDED": "Eksport sesji jest wysyłany.",
                "EXPORT_FAILED": "Wystąpił błąd."
            },
            "EASY-ACCESS": {
                "MANAGE-PUBLIC-ACCESS": "Zarządzaj dostępem publicznym",
                "MANAGE-PUBLIC-ACCESS-TEXT": "Możesz przestać udostępniać ten przepływ pracy, usuwając dostęp publiczny.",
                "GENEATE-ACCESS-TEXT": "Możesz wygenerować publiczny link i kod QR, aby utworzyć łatwy dostęp do tego przepływu pracy.",
                "ENABLE-PASSWORD": "Włącz hasło",
                "GENERATE-ACCESS": "Generuj",
                "LINK": "Link",
                "COPY": "Kopiuj",
                "QR-CODE": "Kod QR",
                "DOWNLOAD": "Pobierz",
                "SECURITY": "Bezpieczeństwo",
                "PASSWORD-PROTECTED": "Chronione hasłem",
                "PUBLIC": "Publiczne",
                "DELETE-ACCESS": "Usuń dostęp publiczny",
                "EASY-ACCESS-TITLE": "{{ shortName }} Łatwy dostęp do przepływu pracy",
                "OPEN-WORKFLOW-NAME": "Zamierzasz otworzyć",
                "GUEST-EMAIL": "Email gościa",
                "REQUIRED": "To pole jest wymagane",
                "GUEST-PASSWORD": "Hasło dla gości",
                "OPEN": "OTWÓRZ",
                "OPEN-APP": "Sugerujemy otwarcie tego przepływu pracy w naszej aplikacji, aby uzyskać lepsze wrażenia.",
                "COPY-LINK-TEXT": "Skopiuj link do schowka, aby otworzyć ten przepływ pracy po uruchomieniu aplikacji.",
                "DOWNLOAD-APP": "POBIERZ APLIKACJĘ",
                "DOWNLOAD-SMARTGLASSES-APP": "POBIERZ APLIKACJĘ DLA OKULARÓW INTELIGENTNYCH",
                "OR": "LUB",
                "CONTINUE-WITH-BROWSER": "Kontynuuj w przeglądarce",
                "PASSWORD-PROTECTED-TEXT": "Gdy hasło jest włączone, użytkownicy, którzy mają publiczny link lub kod QR, mogą uzyskać dostęp do tego przepływu pracy tylko po wprowadzeniu hasła.",
                "CREATE-PASSWORD": "Utwórz hasło",
                "ENTER-EMAIL": "Wprowadź swój email",
                "ENTER-WORKFLOW-PASSWORD": "Wprowadź hasło przepływu pracy",
                "DELETE-QR-TEXT": "Aby zmienić typ zabezpieczenia Łatwego dostępu, należy usunąć Łatwy dostęp i wygenerować ponownie.",
                "LOADING-WORKFLOW": "Ładowanie przepływu pracy...",
                "UNABLE-TO-LOAD": "Nie można załadować przepływu pracy",
                "RETRY": "Spróbuj ponownie",
                "GUEST-ACCESS": {
                    "TOKEN-MISSING": "Token brakuje lub jest nieprawidłowy",
                    "ID-MISSING": "Brakuje ID przepływu pracy lub podstawowego adresu URL",
                    "WORKFLOW-NOT-PUBLISHED": "Przepływ pracy nie jest opublikowany",
                    "PUBLIC-ACCESS": "Dostęp publiczny już istnieje",
                    "NO-PUBLIC-ACCESS": "Brak dostępu publicznego"
                },
                "QR-INFORMATION": "Informacje QR"
            },
            "VIDEO-FLOW-DASHBOARD": {
                "TITLE": "Przepływy wideo",
                "CREATE-VIDEO-FLOW": "Utwórz przepływ wideo",
                "CREATED-BY-AI": "Utworzone przez AI",
                "VERSION": "Wersja",
                "NO-VIDEO-FLOWS-FOUND": "Nie znaleziono przepływów wideo",
                "CLEAR-ALL": "Wyczyść wszystko",
                "CONFIRM-VIDEO": "Potwierdź wideo",
                "CONFIRM-VIDEO-TITLE": "Potwierdź konwersję wideo",
                "CONFIRM-VIDEO-MESSAGE": "Czy na pewno chcesz przekonwertować ten przepływ wideo na workflow? Po potwierdzeniu nie będziesz mógł edytować wideo.",
                "CONFIRM-VIDEO-BUTTON": "Potwierdź i konwertuj",
                "MAKE-WORKFLOW-SUCCESSFUL": "Pomyślnie przekonwertowano na workflow",
                "MAKE-WORKFLOW-ERROR": "Nie udało się przekonwertować na workflow",
                "UPLOAD-VIDEO-DESCRIPTION": "Prześlij swoje wideo, aby automatycznie wygenerować przewodnik workflow krok po kroku.",
                "VIDEO-DURATION-LIMIT": "Czas trwania wideo nie może przekraczać 30 minut.",
                "VIDEO-UPLOADED-SUCCESS": "Wideo zostało pomyślnie przesłane!",
                "SELECT-VIDEO": "Wybierz wideo",
                "CHANGE-VIDEO": "Zmień wideo",
                "CREATE-BUTTON": "Utwórz",
                "AI-PROCESSING": "Przetwarzanie AI w toku",
                "SPLITTING-VIDEO": "Dzielenie wideo na segmenty",
                "TRANSCRIBING-VIDEO": "Transkrypcja zawartości wideo",
                "PROCESS-WARNING": "Ten proces może potrwać do 10 minut. Proszę nie zamykać tego okna."
            },
            "NAVBAR": {
                "PRECALL_TEST": "Test wstępny",
                "PRECALL_END_SESSION": "Proszę zakończyć sesję przed testem prefall.",
                "LOGOUT": "Wyloguj",
                "LANGUAGE": "Język",
                "LOGOUT_MODAL_TITLE": "Wyloguj?",
                "LOGOUT_MODAL_MESSAGE": "To cię wylogowuje.",
                "CAUTION": "UWAGA: Spowoduje to wylanie cię bez zakończenia sesji. Supp-up Windows i inne informacje po sesji mogą się zgubić (E.G. Eksport sesji)!",
                "LOGOUT_MODAL_MESSAGE_IN_ROOM": "Opuścisz sesję i wylogujesz się.",
                "LOGOUT_MODAL_NO": "Anuluj",
                "LOGOUT_MODAL_YES": "Wyloguj",
                "LOGOUT_FAILED": "Wystąpił błąd podczas wylogowania",
                "HELP_CENTER": "Centrum pomocy",
                "PROFILE_TITLE": "Profil",
                "PROFILE_NAME": "Nazwa",
                "PROFILE_EMAIL": "E-mail",
                "PROFILE_PASSWORD": "Hasło",
                "PROFILE_CHANGE_LINK": "Zmiana",
                "PROFILE_ADD_LINK": "Dodać",
                "PROFILE_CLOSE": "Anuluj",
                "CHANGE_PASS_TITLE": "Zmień hasło",
                "CHANGE_PASS_OLD_PASS": "Stare hasło",
                "CHANGE_PASS_NEW_PASS": "nowe hasło",
                "CHANGE_PASS_RPT_PASS": "Potwierdź hasło",
                "CHANGE_PASS_REQUIRED": "wymagane hasło",
                "CHANGE_PASS_NOT_MATCH": "Hasła nie pasują do siebie",
                "CHANGE_PASS_CLOSE_BTN": "Anuluj",
                "CHANGE_PASS_CHANGE_BTN": "Zmień hasło",
                "CHANGE_PASS_SUCCESS": "Twoje hasło się zmieniło.",
                "CHANGE_PASS_WRONG": "Twoje hasło jest nieprawidłowe.",
                "CHANGE_PASS_FAILED": "zmiana hasła nie powiodła się",
                "CHANGE_EMAIL_TITLE": "Zmień adres e-mail",
                "CHANGE_EMAIL_NEW_EMAIL": "nowy e-mail",
                "CHANGE_EMAIL_RPT_EMAIL": "Potwierdź email",
                "CHANGE_EMAIL_REQUIRED": "Email (wymagany",
                "CHANGE_EMAIL_NOT_VALID": "adres email jest nieprawidłowy",
                "CHANGE_EMAIL_NOT_MATCH": "adresy e-mail nie pasują",
                "CHANGE_EMAIL_CLOSE_BTN": "Anuluj",
                "CHANGE_EMAIL_CHANGE_BTN": "Zmień adres e-mail",
                "CHANGE_EMAIL_SUCCESS": "Twój e-mail się zmienił.",
                "CHANGE_EMAIL_FAILED": "Zmiana poczty e-mail nie powiodła się",
                "FEEDBACK": "Informacja zwrotna",
                "SUCCESS_MESSAGE": "Dziękujemy za złożenie formularza. Nasz zespół wkrótce wróci do ciebie.",
                "CLOSE": "Anuluj",
                "CREATE_NEW_PASS": "Wymagania hasła",
                "UPPERCASE": "Duże litery",
                "LOWERCASE": "Małe litery",
                "NUMBER": "Numer",
                "SPECIAL": "Specjalny",
                "AT_LEAST_PASSWORD_LENGTH": "Przynajmniej {{ passwordlength }} Znaki",
                "OLD_PASSWORD": "Stare hasło",
                "NOT_WHITESPACE": "Twoje hasło nie może zawierać znaków przestrzeni",
                "DO_NOT_CREATE_SIMPLE": "Nie twórz słabych haseł, takich jak \"123456\"",
                "STATUS": {
                    "AVAILABLE": "Dostępny",
                    "BUSY": "Zajęty",
                    "APPEAR_OFFLINE": "Wyglądaj offline"
                }
            },
            "LOBBY": {
                "LOBBY_SHARED": {
                    "ONGOING_CALLS_TITLE": "Trwające połączenia",
                    "ROOMS_TITLE": "Twoje pokoje",
                    "UPCOMING_MEETINGS_TITLE": "Nadchodzące spotkania",
                    "PREVIOUS_MEETINGS_TITLE": "Poprzednie spotkania",
                    "SCHEDULE_MEETING": "Zaplanowane spotkanie",
                    "INSTANT_GUEST_ACCESS": "Natychmiastowy dostęp dla gościa",
                    "INSTANT_GUEST_ACCESS_NO_CALLING": "Nie masz uprawnień do wykonywania połączeń. Skontaktuj się z administratorem.",
                    "INSTANT_GUEST_ACCESS_NO_GUEST_ACCESS": "Nie masz uprawnień do utworzenia linku dostępu dla gościa. Skontaktuj się z administratorem.",
                    "INSTANT_GUEST_ACCESS_NO_PERM": "Nie masz uprawnień do wykonywania połączeń ani tworzenia linku dostępu dla gościa. Skontaktuj się z administratorem.",
                    "LINK_UNAVAILABLE": "Link niedostępny",
                    "JOIN": "DOŁĄCZ",
                    "CANCEL": "ZATRZYMAĆ",
                    "REMOVE": "USUNĄĆ",
                    "NO_ROOM": "Nie masz miejsca.",
                    "NO_MEETING": "Nie masz żadnego spotkania.",
                    "NO_PREV_MEETING": "Nie masz żadnego spotkania.",
                    "NO_OTHER_USERS": "Żadnych innych użytkowników",
                    "SHOW_MORE": "Pokaż {{ count }} Więcej",
                    "SHOW_LESS": "Pokaż mniej"
                },
                "SCHEDULE_MEETING_MODAL": {
                    "TITLE": "Zaplanowane spotkanie",
                    "MEETING_TITLE": "Tytuł*",
                    "MEETING_TITLE_REQUIRED": "Wymagany tytuł",
                    "START_DATE": "Początek",
                    "END_DATE": "Kończyć się",
                    "CLOSE": "Anuluj",
                    "SCHEDULE_SEND": "Harmonogram & Wyślij",
                    "SCHEDULE": "Harmonogram",
                    "CANNOT_SCHEDULE": "Wystąpił błąd podczas planowania spotkania.",
                    "CANNOT_CANCEL_MEETING": "Wystąpił błąd podczas anulowania spotkania.",
                    "ENTER_USERS": "Wprowadź użytkowników.",
                    "SEND_INVITATIONS": "Wysyłać zaproszenia",
                    "INVITATION_EMAIL_LANG": "Język e-maila z zaproszeniem",
                    "SHARE_AFTER": "Link spotkania może być również udostępniony po planowaniu."
                },
                "CANCEL_MEETING_MODAL": {
                    "CANCEL_TITLE": "Anuluj spotkanie",
                    "REMOVE_TITLE": "Usuń spotkanie",
                    "CANCEL_MESSAGE": "Czy na pewno chcesz anulować spotkanie?",
                    "REMOVE_MESSAGE": "Czy na pewno chcesz usunąć spotkanie?",
                    "CLOSE": "Anuluj",
                    "PROCEED": "Przystępować"
                },
                "CONTACTS": {
                    "TITLE": "Użytkownicy.",
                    "NO_PERMISSION": "Nie masz uprawnień, aby zobaczyć listę użytkowników i połączenia.",
                    "NO_CONTACT": "Lista użytkowników jest pusta.",
                    "SELECT_MULTI": "Wybierz wiele",
                    "CALL": "Połączenie",
                    "ADMIN": "Administrator",
                    "COADMIN": "Co-admin.",
                    "EXPERT": "Ekspert",
                    "SUBSCRIBER": "Abonent",
                    "USER": "Użytkownik",
                    "NAME": "Nazwa",
                    "USERNAME": "Nazwa użytkownika",
                    "ROLE": "Rola",
                    "NO_EXPERT": "Wybierz co najmniej jeden ekspert, aby zadzwonić.",
                    "NAME_USERNAME": "Nazwa lub nazwa użytkownika.",
                    "ALL_ROLES": "Wszystkie role."
                },
                "SESSIONS": {
                    "TITLE": "Sesje",
                    "DATE": "Stworzony dalej",
                    "DURATION": "Całkowity czas trwania",
                    "ROOM_NAME": "Pokój",
                    "NO_SESSIONS": "Lista sesje jest pusta.",
                    "PARTICIPANTS": "Uczestnicy",
                    "EXPORT": "Eksportu",
                    "STATUS": "Status",
                    "ON_GOING": "Bieżący",
                    "ENDED": "Zakończony",
                    "FILES": "Akta",
                    "CHAT": "Czat",
                    "SESSION_FILES": {
                        "MULTIPLE_SELECTION": "Wybierz wiele",
                        "DOWNLOAD": "Ściągnij",
                        "DOWNLOAD_STARTED_SOON": "Pobierz rozpocznie się wkrótce",
                        "DOWNLOAD_FAILED": "Pobieranie nie udane",
                        "NO_FILE_IS_ADDED": "W tej sesji nie dodano żadnego pliku ani nie współpracowano.",
                        "SUCCESS_MESSAGE": "Pliki zostały pomyślnie pobrane."
                    },
                    "ATTACHED_TICKET": "Załączony bilet",
                    "SESSION_DETAILS": "Szczegóły sesji",
                    "BACK": "Plecy",
                    "GET_SESSION_EXPORT": "Pobierz eksport sesji",
                    "ATTACH_TO_TICKET": "Dołącz do biletu"
                },
                "TICKETS": {
                    "TITLE": "Zgłoszenia",
                    "NEW_TICKET": "Nowe zgłoszenie",
                    "ALL_ROOMS": "Wszystkie pokoje",
                    "ALL_STATUSES": "Wszystkie statusy",
                    "NO_TICKETS": "Lista biletów jest pusta.",
                    "TICKET_TITLE": "Tytuł",
                    "ROOM": "Pokój",
                    "CREATED_BY": "Utworzył",
                    "CREATED_ON": "Stworzony dalej",
                    "STATUS": "Status",
                    "STATUS_OPEN": "otwarty",
                    "STATUS_IN_PROGRESS": "w trakcie",
                    "STATUS_CLOSED": "Zamknięty",
                    "CLOSE_PICK_TICKET": "ANULUJ",
                    "CREATE_NEW": "DODAJ NOWE",
                    "ATTACH": "PRZYTWIERDZAĆ",
                    "CREATE_TICKET": "Utwórz bilet",
                    "TICKET_DETAILS": "Szczegóły biletu.",
                    "EDIT": "EDYTUJ",
                    "TICKET_TYPE": "Typ zgłoszenia",
                    "ROOM2": "Pokój:",
                    "CREATED_BY2": "Utworzył:",
                    "CREATED_ON2": "Stworzony na:",
                    "ROOM3": "Pokój",
                    "STATUS2": "Status",
                    "PRIORITY": "Priorytet",
                    "ASSIGNEE": "Twórca",
                    "FOLLOW_UP": "Data.",
                    "TICKET_TITLE2": "Tytuł",
                    "TITLE_REQUIRED": "Wymagany tytuł",
                    "DESCRIPTION": "Opis",
                    "DESCRIPTION_REQUIRED": "Wymagany opis",
                    "RESOLUTION": "Rezolucja",
                    "ATTACHED_SESSIONS": "Dołączone sesje.",
                    "NO_ATTACHED_SESSIONS": "Lista załączonych sesji jest pusta",
                    "SESSION_COUNT": "Liczba sesji:",
                    "TOTAL_DURATION": "Całkowity czas trwania:",
                    "PARTICIPANTS2": "Uczestnicy:",
                    "COUNT_SESSIONS": " {{count}} sesje",
                    "DATE": "Data",
                    "ROOM_NAME": "Nazwa pokoju",
                    "PARTICIPANTS": "Uczestnicy",
                    "DURATION": "Czas trwania",
                    "GUEST": "(Gość)",
                    "CANCEL": "ZATRZYMAĆ",
                    "CLOSE": "ANULUJ",
                    "SAVE": "ZAPISAĆ",
                    "CREATE": "UTWÓRZ",
                    "CREATED_BETWEEN": "Zakres dat",
                    "ALL_CREATORS": "Wszyscy twórcy",
                    "SEND_VIA_EMAIL": "Wyślij pocztą elektroniczną",
                    "DELETE_TICKET": "Usuń bilet",
                    "DELETE_TICKET_MODAL": {
                        "TITLE": "Usuń bilet?",
                        "MESSAGE": "Czy na pewno chcesz usunąć bilet <strong> {title}} </ strong>",
                        "CANCEL": "ZATRZYMAĆ",
                        "DELETE": "KASOWAĆ"
                    },
                    "LOW": "Niski",
                    "MEDIUM": "Środek",
                    "HIGH": "Wysoki",
                    "CHOOSE_TICKET": "Wybierz Bilet",
                    "ERRORS": {
                        "TICKET_ALREADY_ATTACHED": "Bilet już dołączony.",
                        "ERROR_OCCURED": "Wystąpił błąd.",
                        "PERMISSION_DENIED": "Odmowa pozwolenia.",
                        "MISSING_PARAMETERS": "Brakuje parametrów",
                        "FILE_ALREADY_EXIST": "Plik już istnieje"
                    },
                    "FILES": "Akta",
                    "UPLOAD_FILE": "PRZESYŁANIE PLIKU"
                },
                "ARCHIVES": {
                    "ARCHIVE_LIST": {
                        "LOADING": "Ładowanie",
                        "CREATED_AT": "Utworzono at",
                        "SIZE": "Rozmiar",
                        "STATUS": "Status",
                        "DOWNLOAD": "Ściągnij",
                        "AVAILABLE": "dostępny",
                        "DISCONNECTED": "niepowiązany",
                        "DELETED": "usunięty",
                        "EXPIRED": "wygasły",
                        "WAITING": "Czekanie",
                        "FAILED": "przegrany",
                        "REFRESH": "Odświeżać",
                        "NO_ARCHIVE_MESSAGE": "Nie ma nagrania rozmowy wideo",
                        "NAME": "Imię",
                        "STORAGE": "Przechowywanie",
                        "DURATION": "Czas trwania",
                        "ARCHIVES": "Nagrania rozmów wideo",
                        "PLAY": "Grać",
                        "DELETE": "Usunąć",
                        "DOWNLOAD_ARCHIVE": {
                            "TITLE": "Pobierz rekord",
                            "GENERATING": "Generowanie adresu URL pobierania",
                            "GENERATED": "Pobierz wygenerowany adres URL",
                            "CANNOT_GENERATED": "Nie można wygenerować adresu URL pobierania.",
                            "DOWNLOAD": "Pobierać",
                            "CLOSE": "Anuluj"
                        },
                        "DELETE_ARCHIVE": {
                            "TITLE": "Usuń rekord",
                            "MESSAGE": "Nagranie rozmowy wideo zostanie usunięte.",
                            "CAUTION": "UWAGA: ten rekord zostanie również usunięty z magazynu platformy Azure.",
                            "CANCEL": "Anulować",
                            "DELETE": "Usunąć"
                        }
                    }
                },
                "CONVERTER": {
                    "TITLE": "Konwerter",
                    "STP_ONLY": "Obsługiwane są tylko formaty plików .Step.",
                    "ERROR_UPLOAD": "Wystąpił błąd podczas przesyłania pliku.",
                    "DRAG": "Przeciągnij i upuść swój plik tutaj",
                    "OR": "lub",
                    "CHOOSE": "Wybierz plik",
                    "CONVERT": "Konwertuj",
                    "SUPPORTED": "Obsługiwane formaty plików:",
                    "BACK": "Plecy",
                    "DOWNLOAD": "Ściągnij",
                    "ERROR_LOAD": "Wystąpił błąd podczas ładowania obiektu."
                },
                "WHATSNEW": {
                    "WHATSNEW_TITLE": "Co nowego",
                    "NO_UNREAD_UPDATE": "Brak nieprzeczytanej aktualizacji"
                },
                "JOIN_MODAL": {
                    "JOIN": "DOŁĄCZ",
                    "CALL": "POŁĄCZENIE",
                    "CANCEL": "ZATRZYMAĆ",
                    "MIRROR_VIDEO": "Lustrzane wideo.",
                    "PREFERRED_RESOLUTION": "Preferowana rozdzielczość",
                    "RESOLUTION_NOTE": "Uwaga: jeśli urządzenie nie obsługuje żądanej rozdzielczości, zostanie użyta następna największa rozdzielczość.",
                    "CAM_MIC_PERM_REQUIRED": "Wymagane uprawnienia do aparatu i mikrofonu",
                    "CAM_MIC_PERM_DENIED": "Odmowa dostępu do kamery lub mikrofonu",
                    "CAM_MIC_CANT_ACCESS": "Nie możemy uzyskać dostępu do aparatu lub mikrofonu",
                    "JOIN_CAM_OFF": "Dołącz do aparatu wyłączony",
                    "JOIN_MIC_OFF": "Dołącz do mikrofonu wyłączonego",
                    "JOIN_CAM_MIC_OFF": "Dołącz do aparatu i wyłączonego mikrofonu",
                    "JOIN_NO_DEVICE": "Dołącz bez kamery i mikrofonu",
                    "ALLOW_ACCESS": "Musisz zezwolić na dostęp do aparatu i mikrofonu w ustawieniach przeglądarki (po otrzymaniu dostępu, nadal możesz wyłączyć aparat lub mikrofon).",
                    "TRY_AGAIN": "Spróbuj ponownie / odświeżyć stronę i wybierz \"Zezwalaj\" po wyświetleniu monitu przez przeglądarkę."
                },
                "NO_DEVICE_MODAL": {
                    "TITLE": "Nie znaleziono urządzenia",
                    "JOIN_BODY": "Do tego urządzenia nie jest podłączony mikrofon ani kamera. Inni użytkownicy nie będą mogli Cię słyszeć ani widzieć przez to urządzenie. Czy nadal chcesz dołączyć?",
                    "CALL_BODY": "Do tego urządzenia nie jest podłączony mikrofon ani kamera. Inni użytkownicy nie będą mogli Cię słyszeć ani widzieć przez to urządzenie. Czy nadal chcesz zadzwonić?",
                    "CANCEL": "Zatrzymać",
                    "JOIN": "Dołącz mimo wszystko",
                    "CALL": "Dzwoń mimo wszystko"
                },
                "AGREEMENT_MODAL": {
                    "TITLE": "Przetwarzanie i bezpieczeństwo formularza homologacji danych osobowych",
                    "REJECTION_BUTTON": "Odrzucić",
                    "AGREEMENT_BUTTON": "Zgadzać się"
                },
                "CHECK_AGREEMENT_MODAL": {
                    "TITLE": "Anuluj umowę?",
                    "ERROR": "Wystąpił błąd.",
                    "STATEMENT": "Gdy nie akceptujesz umowy, nie będziesz mógł zalogować się do systemu.",
                    "CANCEL_BUTTON": "Zatrzymać",
                    "PROCEED_BUTTON": "Przystępować"
                },
                "JOIN_UNKNOWN_ERROR": "Wystąpił błąd podczas łączenia pokoju.",
                "JOIN_CONCURRENT_ERROR": "Osiągnąłeś limit użytkownika konta. Aby uzyskać więcej informacji, skontaktuj się z administratorem.",
                "JOIN_EXPERT_CONCURRENT_ERROR": "Osiągnąłeś swój ekspert współbieżny limit użytkownika. Aby uzyskać więcej informacji, skontaktuj się z administratorem.",
                "NO_TRAINING_LICENSE": "Wystąpił problem z licencją w sali szkoleniowej. Skontaktuj się z administratorem.",
                "TRAINING_LICENSE_EXPIRED": "Twoja licencja w sali szkoleniowej została wygasła. Skontaktuj się z administratorem.",
                "ASK_TRAINING_HOST": "Wystąpił błąd podczas łączenia pokoju treningowego. Skontaktuj się z hostem.",
                "JOIN_CALL_IN_PROGRESS": "W Twojej osobistej sali konferencyjnej znajduje się kolejne połączenie.",
                "NOT_SUPPORTED_TITLE": "Niezgodna przeglądarka",
                "NOT_SUPPORTED_MESSAGE": "Twoja przeglądarka nie jest kompatybilna. Użyj Google Chrome, Mozilla Firefox, Safari lub Microsoft Edge (wersja 79 lub nowszy).",
                "NO_IOS_MESSAGE": "Twoja przeglądarka nie jest kompatybilna. Użyj aplikacji zdalnej {{ appName }} lub użyj Safari.",
                "IOS_VERSION_MESSAGE": "Twoja przeglądarka nie jest kompatybilna. Użyj aplikacji Remote {{ appName }.",
                "NOT_SUPPORTED_CLOSE": "Anuluj",
                "IDLE_MODAL_TITLE": "Błąd",
                "IDLE_MODAL_MESSAGE": "Nie przeprowadziłeś żadnej transakcji przez dłuższy okres.",
                "IDLE_MODAL_COUNT": "Zostaniesz wylogowany w {{ count }} sekundy.",
                "IDLE_MODAL_OK": "Wróciłem",
                "ARCHIVE_PERMISSION_MODAL": {
                    "TITLE": "Zezwalaj na nagrywanie?",
                    "MESSAGE": "Spotkanie w tym pokoju zostanie zarejestrowane. Musisz zezwolić na nagrywanie wideo, aby dołączyć do tego pokoju.",
                    "DENY": "Zaprzeczyć",
                    "ALLOW": "Pozwalać na"
                }
            },
            "ROOM": {
                "OT_ERROR_MODAL": {
                    "TITLE": "Błąd",
                    "CLOSE": "Kontynuować mimo wszystko",
                    "REJOIN": "Zareplikować",
                    "ENDCALL": "Opuścić",
                    "ERRORS": {
                        "INTERNET": "Nie można połączyć się z sesją. Proszę sprawdzić swoje połączenie z internetem.",
                        "TRY_AGAIN": "Wystąpił błąd podczas łączenia się z sesją. Spróbuj ponownie później.",
                        "UNKNOWN": "Wystąpił błąd podczas łączenia się z sesją.",
                        "PUBLISHER_FAILED": "Udostępnianie strumienia wideo z innymi uczestnikami nie powiodło się.",
                        "PUBLISHER_CAM_MIC_ACCESS": "Upewnij się, że aparat i mikrofon jest pracujący, a uprawnienia aparatu / mikrofonu są przyznawane.",
                        "SUBSCRIBER_FAILED": "Połączenie z jednym z uczestników strumienia wideo nie powiodło się."
                    }
                },
                "SIDEBAR": {
                    "CHAT_TITLE": "Czat",
                    "PARTICIPANTS_TITLE": "Uczestnicy",
                    "FILES_TITLE" : "Akta",
                    "SETTINGS_TITLE": "Ustawienia",
                    "SHOW_TICKET": "Pokaż bilet",
                    "ATTACH_TO_TICKET": "Dodaj zgłoszenie.",
                    "ATTACH_SESSION_TO_TICKET": "Dołącz sesję na bilet",
                    "OPEN_WORKFLOW": "Otwórz przepływ pracy",
                    "CHAT": {
                        "SEE_TRANSLATION": "Zobacz tłumaczenie",
                        "SEE_ORIGINAL": "Zobacz oryginał",
                        "TRANSLATING": "Tłumaczenie",
                        "FILE_SHARE": {
                            "DRAG_HERE": "Przeciągnij pliki tutaj",
                            "UPLOAD_TITLE": "Prześlij pliki",
                            "IMAGE": "Obraz",
                            "PDF": "Pdf.",
                            "3D_OBJECT": "Obiekt 3D.",
                            "OTHER": "Inny",
                            "MULTIPLE_OBJECTS": "Znaleźliśmy wiele obiektów w swoich plikach. Prześlij jeden obiekt (z teksturami, jeśli są dostępne) naraz.",
                            "LARGER_THAN": "Większe niż {{ megabytes }} MB",
                            "FILETYPE_PROHIBITED": "Typ pliku zabroniony",
                            "START_UPLOAD": "PRZEŚLIJ",
                            "CANCEL_UPLOAD": "ZATRZYMAĆ",
                            "CLOSE_UPLOAD": "ANULUJ",
                            "CANCEL_MODAL_TITLE": "Zatrzymaj przesyłanie?",
                            "CANCEL_MODAL_MESSAGE": "Spowoduje to zatrzymanie aktualnych przesyłek.",
                            "CANCEL_MODAL_CLOSE": "Anuluj",
                            "CANCEL_MODAL_CANCEL": "Zatrzymać"
                        },
                        "DELETE_FILE_MODAL": {
                            "TITLE": "Usunąć plik?",
                            "MESSAGE": "Plik zostanie usunięty",
                            "CLOSE": "Anuluj",
                            "DELETE": "Kasować"
                        },
                        "FILE_DETAILS_MODAL": {
                            "TITLE": "Szczegóły pliku",
                            "FILENAME": "Nazwa pliku",
                            "SIZE": "Rozmiar",
                            "TYPE": "Rodzaj",
                            "UPLOAD_TIME": "Czas przesyłania",
                            "DOWNLOAD": "Ściągnij",
                            "CLOSE": "Anuluj",
                            "FILECOUNT": "Całkowita liczba plików"
                        },
                        "COLLABORATE": "Współpracować",
                        "CLOSE_COLLABORATION": "Bliska współpraca",
                        "DOWNLOAD": "Ściągnij",
                        "DELETE": "Kasować",
                        "DETAILS": "Detale",
                        "SEND_TO_FILES": "Wyślij do plików",
                        "FILE_DELETED": "Usunięto plik",
                        "JOIN_ROOM": "{{ owner_info }} dołączył do pokoju.",
                        "LEAVE_ROOM": "{{ owner_info }}  opuścił pokój.",
                        "REACTION": "{{ owner_info }}  Wysłano reakcję.",
                        "REQUEST_SCREENSHOT": "{{ owner_info }} wziął migawkę.",
                        "SHARE_SCREENSHOT": "{{ owner_info }} udostępnił migawkę.",
                        "SAVED_COLLABORATION": "Zapisana współpraca.",
                        "SHARE_IMAGE": "{{ owner_info }} udostępnił obraz.",
                        "SHARE_PDF": "{{ owner_info }}  udostępnił PDF.",
                        "SHARE_OTHER": "{{ owner_info }} udostępnił plik.",
                        "SHARE_OBJECT": "{{ owner_info }}  udostępnił obiekt 3D.",
                        "COLLABORATED": "{{ owner_info }}  rozpoczął współpracę.",
                        "TYPE_HERE": "Pisz tutaj...",
                        "PLEASE_WAIT_OTHERS": "Poczekaj, aż inni użytkownicy dołączą.",
                        "DOWNLOAD_STARTED_SOON": "Pobierz rozpocznie się wkrótce",
                        "DOWNLOAD_FAILED": "Pobieranie nie udane",
                        "DOWNLOAD_OBJECT_NOT_SUPPORTED": "Pobieranie tego obiektu nie jest jeszcze obsługiwane.",
                        "DOWNLOAD_NOT_SUPPORTED": "To pobieranie nie jest jeszcze obsługiwane.",
                        "CLOSE_PREV_COLLABORATION_TITLE": "Zamknij bieżącą współpracę plików?",
                        "CLOSE_COLLABORATION_TITLE": "Zamknij kolaborowanie plików?",
                        "CLOSE_PREV_COLLABORATION_MESSAGE": "Spowoduje to zamknięcie bieżącej współpracy i rozpocznij nowy.",
                        "CLOSE_COLLABORATION_MESSAGE": "Spowoduje to zamknięcie współpracy.",
                        "CLOSE_PREV_COLLABORATION_YES": "Przystępować",
                        "CLOSE_PREV_COLLABORATION_NO": "Anuluj",
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "Otwarty File-Collaboration?",
                            "MESSAGE_AUTHORIZED": "Istnieje przypięte okno. Czy chcesz go usunąć i otworzyć współpracę plików?",
                            "MESSAGE_UNAUTHORIZED": "Nie można otworzyć współpracy plików, ze względu na przypięte okno.",
                            "CANCEL": "Zatrzymać",
                            "CLOSE": "Anuluj",
                            "PROCEED": "Przystępować"
                        },
                        "CLOSE_ARPLUS_BEFORE_COLL": {
                            "TITLE": "Zamknij ar +?",
                            "MESSAGE": "Musisz zamknąć ar +, zanim będziesz mógł otworzyć współpracę. Czy na pewno chcesz zamknąć Ar +?",
                            "NO": "Nie",
                            "YES": "tak"
                        }
                    },
                    "PARTICIPANTS": {
                        "HOST": "(Gospodarz)",
                        "LOWER_ALL_HANDS": "Obniżyć wszystkie ręce",
                        "RAISED_HAND": "{{ name }} podniósł rękę.",
                        "DENIED_PUBLISH": "{{ name }} odmówił połączenia z wideo / audio.",
                        "PARTICIPANT_LIMIT_REACHED": "Osiągnięto limit uczestnika komunikacji wideo / audio.",
                        "CALLING": "Dzwonienie: {{ participants }}"
                    },
                    "FILES": {
                        "INFO_TEXT": "Wszyscy eksperci i współadministratorzy, którzy mają dostęp do tego pokoju, mogą przeglądać i modyfikować pliki w tej sekcji",
                        "DOWNLOAD": "Ściągnij",
                        "SEND_TO_SESSION": "Wyślij do sesji",
                        "DELETE": "Usuwać",
                        "UPLOAD_FILE": "Przesyłanie pliku",
                        "FILE_CONTENTS": "Zawartość pliku:",
                        "FILE_NAME": "Nazwa pliku:",
                        "FILE_SIZE": "Rozmiar pliku:",
                        "TOTAL_SIZE": "Całkowity rozmiar:",
                        "DOWNLOAD_STARTED_SOON": "Pobierz rozpocznie się wkrótce",
                        "DOWNLOAD_FAILED": "Pobieranie nie udane",
                        "DELETE_MODAL": {
                            "TITLE_DELETE": "Usunąć plik?",
                            "MESSAGE_DELETE": "Czy na pewno chcesz usunąć ten plik?",
                            "CANCEL": "Zatrzymać",
                            "DELETE": "Usuwać"
                        }
                    },
                    "SETTINGS": {
                        "MICROPHONE": "Mikrofon",
                        "CAMERA": "Kamera",
                        "TRANSLATE_OTHERS_MSG_TO": "Przetłumacz wiadomości innych do:",
                        "TRANSLATE_MY_MSG_TO": "Przetłumacz moje wiadomości do:",
                        "CREATE_GUEST_ACCESS": "Utwórz dostęp do gości",
                        "GENERATING": "Generowanie",
                        "GUEST_ACCESS": "Dostęp dla gościa",
                        "COPY_LINK": "Kopiuj",
                        "LINK_COPIED": "Link skopiowany do schowka",
                        "LINK_GENERATED": "Wygenerowano łączenie sesji",
                        "CANNOT_CREATE_GUEST_ACCESS": "Nie można utworzyć dostępu do gości.",
                        "NO_LINK_PERMISSION": "Nie masz uprawnień do tworzenia łącza dostępu do gości. Skontaktuj się z administratorem.",
                        "SHARE": "Udział",
                        "SHARE_LINK_VIA_SMS": "Udostępnij link za pomocą SMS",
                        "SMS_SEND": "Link został wysłany przez SMS",
                        "OPENING": "Otwarcie",
                        "SEND": "Wyślij",
                        "SMS_LIMIT_REACHED": "Osiągnięto limit SMS. Skontaktuj się z administratorem.",
                        "ERROR_OCCURED": "Wystąpił błąd.",
                        "SMS_LICENSE_PERMISSION": "Nie masz uprawnień do wysyłania SMS. Skontaktuj się z administratorem.",
                        "RESHARE": "Możesz udostępniać link raz na minutę.",
                        "DIDNT_GET": "Nie otrzymałeś linku?",
                        "PHONE_NUMBERS": "Ostatnio używane numery telefonów",
                        "RESEND": "Wysłać ponownie",
                        "CANCEL": "Zatrzymać",
                        "CONNECT_VIA_FIELD_CODE": "Połącz się z użytkownikiem za pomocą kodu pola",
                        "CONNECT": "Połączyć",
                        "INVITATION_SENT": "Zaproszenie zostało wysłane do użytkownika.",
                        "INVITATION_COULD_NOT_SENT": "Zaproszenie nie można było wyślij do użytkownika.",
                        "FIELD_CODE": "Kod polowy."
                    }
                },
                "VIDEO_CHAT": {
                    "AUDIO_BITRATE": "Bitrat audio.",
                    "AUDIO_PACKET_LOSS": "Utrata pakietów audio.",
                    "VIDEO_BITRATE": "Bitrate wideo",
                    "VIDEO_PACKET_LOSS": "Utrata pakietów wideo",
                    "RESOLUTION": "Rezolucja",
                    "WAIT_OTHER_USERS": "Poczekaj, aż inni użytkownicy dołączą.",
                    "WAIT_EXPERT": "Poczekaj, aż ekspert dołączył.",
                    "WAIT_MASTER": "Poczekaj, aż gospodarz rozpocznie sesję.",
                    "START_SESSION": "Rozpocznij sesję.",
                    "HOST_WITHDRAW_REQUEST": "Host wycofał żądanie wideo / audio",
                    "NO_CAM_MIC": "Twoja kamera i mikrofon są niedostępne.",
                    "NO_CAM": "Twój aparat jest niedostępny.",
                    "NO_MIC": "Twój mikrofon jest niedostępny.",
                    "JOIN_VIDEO_AUDIO_MODAL": {
                        "TITLE": "Dołącz do komunikacji wideo / audio?",
                        "MESSAGE": "Host prosi o włączenie wideo / audio.",
                        "DENY": "Zaprzeczyć",
                        "ACCEPT": "Zaakceptować"
                    },
                    "PUBLISHER": {
                        "YOU": "ty",
                        "SCREEN_SHARE_MESSAGE": "Udostępniasz swój ekran",
                        "STOP_SCREEN_SHARING": "Przestań udostępniać"
                    },
                    "SUBSCRIBER": {
                        "APP_NOT_UP_TO_DATE_FOR_STATS": "Nie można wyświetlić statusu sieci, ponieważ aplikacja tego uczestnika nie jest aktualna.",
                        "SNAPSHOT": "Migawka",
                        "AR_PLUS": "AR współpracować",
                        "SCREENSHOT_REQUESTED": "Wykonano migawkę",
                        "VIDEO_NOT_AVAILABLE": "Wideo nie jest dostępne",
                        "WEAK_SIGNAL": "Słaby sygnał",
                        "AUDIO_ONLY_MODE": "Tryb tylko audio.",
                        "FLASH": "Lampa błyskowa",
                        "AR_NOT_AVAILABLE": "Nie jest dostępny dla tego urządzenia.",
                        "CHARGING": "Ładowanie",
                        "LOW_BATTERY": "Niski poziom baterii",
                        "CLOSE_AR_PLUS_MODAL": {
                            "TITLE": "Zamknij AR +?",
                            "MESSAGE": "Czy na pewno chcesz zamknąć AA +?",
                            "NO": "Nie",
                            "YES": "tak"
                        },
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "Otwarty AR +?",
                            "MESSAGE_AUTHORIZED": "Istnieje przypięte okno. Chcesz go rozpowszechniać i otworzyć Ar +?",
                            "MESSAGE_UNAUTHORIZED": "Nie można otworzyć AR + z powodu przypiętego okna.",
                            "CANCEL": "Zatrzymać",
                            "CLOSE": "Anuluj",
                            "PROCEED": "Przystępować"
                        },
                        "REFRESH_SURFACES": "Odśwież powierzchnie",
                        "AR_PLUS_LOCKED": "AR+ jest zablokowany. Najpierw odblokuj AR+."
                    },
                    "CONTROL_BAR": {
                        "SHARE_SCREEN": "Udostępnianie ekranu",
                        "STOP_SHARE": "Przestań udostępniać",
                        "MIC_OFF": "Mikrofon",
                        "CAM_OFF": "Kamera",
                        "CAM_MIC_CANT_ACCESS": "Nie możemy uzyskać dostępu do aparatu ani mikrofonu",
                        "LEAVE_CALL": "Opuścić",
                        "LEAVE_SESSION": "Zostaw sesję.",
                        "LEAVE_MEETING": "Opuść spotkanie",
                        "END_SESSION_FOR_ALL": "Sesja końcowa dla wszystkich",
                        "END_MEETING_FOR_ALL": "Zakończ spotkanie dla wszystkich",
                        "ENDCALL_MODAL": {
                            "TITLE_LEAVE": "Zostaw sesję?",
                            "TITLE_LEAVE_MEETING": "Opuścić spotkanie?",
                            "TITLE_END_ALL": "Koniec sesji dla wszystkich?",
                            "TITLE_END_ALL_MEETING": "Zakończyć spotkanie dla wszystkich?",
                            "MESSAGE_LEAVE": "Czy na pewno chcesz opuścić sesję?",
                            "MESSAGE_END_ALL": "Czy na pewno chcesz zakończyć sesję?",
                            "MESSAGE_LEAVE_MEETING": "Czy na pewno chcesz opuścić spotkanie?",
                            "MESSAGE_END_ALL_MEETING": "Czy na pewno chcesz zakończyć spotkanie?",
                            "CANCEL": "Zatrzymać",
                            "END": "Kończyć się",
                            "LEAVE": "Opuścić",
                            "REMOVE_MEETING_LINK": "Wyłącz także i usuń link do spotkania"
                        },
                        "RAISE_HAND": "Podnieś rękę",
                        "LOWER_HAND": "Dolna ręka",
                        "RECORD": "Nagrywanie",
                        "AUTO_RECORD": "Auto Record.",
                        "STOP_RECORD": "Zatrzymaj rekord",
                        "CANCEL": "Anulować żądanie",
                        "ASK_ARCHIVE_PERMISSION": "Uzyskaj pozwolenie na nagrywanie",
                        "REACTION": "Reakcja",
                        "EXTENSION_MODAL_TITLE": "Wymagany rozszerzenie",
                        "EXTENSION_MODAL_MESSAGE": "Google Chrome wymaga rozszerzenia dla funkcji udostępniania ekranu. Zainstaluj rozszerzenie lub użyj Mozilla Firefox.",
                        "EXTENSION_MODAL_NO": "Anuluj",
                        "EXTENSION_MODAL_YES": "Otwarty stronę rozszerzenia.",
                        "ARCHIVE_NO_PERMISSION": "Nie masz uprawnień do nagrywania tej sesji. Skontaktuj się z administratorem.",
                        "P2P_NO_ARCHIVE": "Nagraj niedostępny dla połączeń wideo peer-to-peer. Skontaktuj się z administratorem.",
                        "SCREEN_SHARE_UPDATE": "Twoja aktualna wersja przeglądarki nie obsługuje udostępniania ekranu. Proszę zaktualizować przeglądarkę.",
                        "SCREEN_SHARE_NOT_SUPPORTED": "Twoja przeglądarka nie obsługuje udostępniania ekranu.",
                        "SCREEN_SHARE_USE_OTHER": "Twoja przeglądarka nie obsługuje udostępniania ekranu. Użyj Google Chrome lub Mozilla Firefox.",
                        "SCREEN_SHARE_FAILED": "Nie można udostępniać ekranu.",
                        "ARCHIVE_REQUESTED": "Nagrywanie wideo zostanie uruchomione. Twoja zgoda jest wymagana.",
                        "ARCHIVE_REQUESTED_WITH_NAME": "{{ name }} chce rozpocząć nagrywanie wideo. Twoja zgoda jest wymagana.",
                        "DENY": "Zaprzeczyć",
                        "ALLOW": "Pozwalać na"
                    },
                    "PDF_COLLABORATION": {
                        "PREVIOUS_PAGE": "Poprzednia strona",
                        "NEXT_PAGE": "Następna strona"
                    },
                    "COLLABORATION_SHARED": {
                        "SOME_USERS_CANNOT_LOAD": "Niektórzy użytkownicy nie mogą załadować współpracy plików.",
                        "DOWNLOAD_FAILED": "Nie można pobrać współpracy plików",
                        "END_COLL_TITLE": "Zamknij kolaborowanie plików?",
                        "END_COLL_MESSAGE": "Spowoduje to zamknięcie współpracy.",
                        "END_COLL_NO": "Anuluj",
                        "END_COLL_YES": "Przystępować",
                        "ALREADY_ENDED": "Collaboration pliku już się zakończył.",
                        "CANNOT_END_COLLABORATION": "Nie można zakończyć współpracy",
                        "ANNOTATE": "Komentować",
                        "FULLSCREEN": "Pełny ekran",
                        "DOWNLOAD_COLLABORATION": "Pobieraj współpracę.",
                        "SNAPSHOT_COLLABORATION": "Współpraca migawki",
                        "UNDO": "Cofnij",
                        "REDO": "Przerobić",
                        "REVERT": "Odwracać",
                        "RELOAD": "Przeładować"
                    },
                    "TRY_TO_FOCUS_MODAL": {
                        "TITLE": "Okno PIN?",
                        "MESSAGE": "Przypinienie nie jest możliwe podczas trybu AR +. Zamknij ar + i przypnij okno?",
                        "CANCEL": "Zatrzymać",
                        "PROCEED": "Przystępować"
                    }
                }
            },
            "RECONNECT_ROOM": {
                "RECONNECT_MESSAGE": "Coś poszło nie tak. Staramy się ponownie dołączyć cię do rozmowy."
            },
            "SESSION_RATING": {
                "BAD": "Zły",
                "POOR": "Słaby",
                "FAIR": "Sprawiedliwy",
                "GOOD": "Dobry",
                "EXCELLENT": "Świetny",
                "RATING_MESSAGE": "Jak była jakość sesji?",
                "REVIEW_MESSAGE": "Powiedz nam, dlaczego (opcjonalnie)",
                "SUCCESS_MESSAGE": "Dziękujemy za ocenę sesji.",
                "CLOSE": "Anuluj",
                "SUBMIT": "Składać",
                "DISMISS": "Odrzucać"
            },
            "PRECALL_TEST": {
                "BACK_TO_LOBBY": "Powrót do Lobby",
                "RUN_PRECALL_TEST": "Uruchom test wstępny",
                "WHAT_TEST": {
                    "TITLE": "Zamierzamy przetestować i przeanalizować",
                    "CONNECTIVITY": "Twoją łączność ze wszystkimi serwerami mediów",
                    "STATS": "Statystyki dotyczące straty bitratu i pakietów",
                    "SETUP": "Konfiguracja sprzętowa i oprogramowania w punkcie końcowym (aparat, mikrofon, przeglądarka)"
                },
                "BEFORE_START": {
                    "TITLE": "Zanim zaczniesz",
                    "MAKE_SURE": "Proszę upewnij się, że:",
                    "RIGHT_NETWORK": "Jesteś w określonej sieci, którą zamierzasz przetestować",
                    "TCP_PORT_OPEN": "Masz otwarty port TCP 443",
                    "RIGHT_HARDWARE": "Wybrałeś odpowiedni aparat i mikrofon",
                    "BANDWITH": "Twoja przepustowość wynosi co najmniej 350 Kb / s (przesyłanie i pobieranie)"
                },
                "HARDWARE_SOFTWARE": {
                    "TITLE": "Konfiguracja sprzętu / oprogramowania",
                    "OPERATING_SYSTEM": {
                        "MESSAGE": "System operacyjny",
                        "BETTER_ALTERNATIVE_IOS": "Możesz pobrać aplikację Remote {{ appName }}, aby uzyskać pełną funkcjonalność i lepsze doświadczenie użytkownika.",
                        "BETTER_ALTERNATIVE_ANDROID": "Możesz pobrać aplikację Remote {{ appName }} z Google Play Store, aby uzyskać pełną funkcjonalność i lepsze doświadczenie użytkownika."
                    },
                    "BROWSER": {
                        "MESSAGE": "Przeglądarka",
                        "NOT_SUPPORTED": "Twoja przeglądarka nie jest wspierana. Użyj Google Chrome, Mozilla Firefox, Safari lub Microsoft Edge (wersja 79 lub nowszy).",
                        "NOT_COMPATIBLE": "Twoja przeglądarka nie jest kompatybilna. Proszę zaktualizować przeglądarkę.",
                        "USE_SAFARI": "Twoja przeglądarka nie jest kompatybilna. Użyj aplikacji zdalnej {{ appName }} lub użyj Safari."
                    },
                    "HARDWARE": {
                        "MESSAGE": "Dostęp kamery / mikrofonu",
                        "CANT_ACCESS": "Nie możemy uzyskać dostępu do aparatu / mikrofonu."
                    }
                },
                "CONNECTION_SERVERS": {
                    "TITLE": "Połączenie z naszymi serwerami",
                    "INTERNET": {
                        "MESSAGE": "połączenie internetowe",
                        "OFFLINE": "Twoje połączenie internetowe wydaje się w trybie offline."
                    },
                    "SERVERS": {
                        "MESSAGE": "Połączenie z naszymi serwerami",
                        "UNKNOWN_ERROR_TRY": "Wystąpił błąd podczas łączenia się z serwerami. Spróbuj ponownie później.",
                        "UNKNOWN_ERROR": "Wystąpił błąd podczas łączenia się z serwerami."
                    }
                },
                "QUALITY": {
                    "TITLE": "Jakość audio / wideo",
                    "AUDIO_VIDEO": {
                        "MESSAGE": "Jakość audio / wideo",
                        "UNKNOWN_ERROR": "Wystąpił błąd podczas testowania jakości audio / wideo.",
                        "VIDEO": "Wideo",
                        "VIDEO_QUALITY": "Jakość wideo:",
                        "VIDEO_PACKET_LOSS": "Utrata pakietów:",
                        "VIDEO_BITRATE": "Bitrate wideo:",
                        "AUDIO": "Audio",
                        "AUDIO_QUALITY": "Jakość dźwięku:",
                        "AUDIO_PACKET_LOSS": "Utrata pakietów:",
                        "AUDIO_BITRATE": "BITRAT AUDIO:",
                        "QUALITY_EXCELLENT": "(Świetny)",
                        "QUALITY_GOOD": "(Dobry)",
                        "QUALITY_BAD": "(Zły)"
                    }
                },
                "STOP_TEST_MODAL": {
                    "TITLE": "Zatrzymaj test?",
                    "MESSAGE": "Spowoduje to powstrzymać test prefall.",
                    "NO": "Anuluj",
                    "YES": "Zatrzymać"
                }
            },
            "EMAIL_RECIPIENTS": {
                "PLACEHOLDER": "Dodaj nowe",
                "SECONDARY_PLACEHOLDER": "Wprowadź adres e-mail",
                "INVALID_EMAIL": "Niewłaściwy format wiadomości email."
            },
            "WORKFLOW_REMOTE": {
                "ERRORS": {
                    "INTEGRATION_ALREADY_USED": "Integracja już używana",
                    "MISSING_PARAMETERS": "Brakuje parametrów",
                    "CALL_IN_PROGRESS": "Trwa rozmowa",
                    "USER_IN_ANOTHER_ROOM": "Użytkownik w innym pokoju"
                }
            }
        },
        "HELP_CENTER": {
            "TITLE": "{{ appName }} Centrum pomocy",
            "TITLE_WITH_REMOTE": "{{ appName }} Remote Centrum pomocy",
            "FAILED": "Wystąpił błąd."
        },
        "EXTERNALS": {
            "JOIN_WITH_LINK": {
                "TITLE": "{{ appName }} zdalny dostęp do gości",
                "SESSION_NOT_FOUND": "Nie można znaleźć sesji.",
                "SESSION_NOT_AVAILABLE": "Ta sesja nie jest już dostępna.",
                "CONCURRENT_LIMIT_REACHED": "Zbliżający się limit użytkownika. Skontaktuj się z administratorem.",
                "EXPERT_CONCURRENT_LIMIT_REACHED": "Osiągnięto ekspert współbieżny limit użytkownika. Skontaktuj się z administratorem.",
                "UNKNOWN_ERROR": "Coś poszło nie tak.",
                "ABOUT_TO_JOIN": "Zamierzasz się dołączyć",
                "ENTER_NAME": "Wpisz swoje imię",
                "NAME_REQUIRED": "Imię (wymagane",
                "NAME_SHORT": "Nazwa musi wynosić co najmniej 2 znaki",
                "JOIN": "DOŁĄCZ",
                "CONTINUE_TO_WEBSITE": "Kontynuuj przez Przeglądarkę"
            },
            "ARCHIVE_LIST": {
                "TITLE": "Rekordy połączeń wideo.",
                "LOADING": "Ładowanie",
                "LOAD_FAILED": "Wystąpił błąd.",
                "CREATED_AT": "Utworzono at",
                "SIZE": "Rozmiar",
                "STATUS": "Status",
                "DOWNLOAD": "Ściągnij",
                "GENERATING": "Generowanie link.",
                "CLICK_TO_DOWNLOAD": "Kliknij, aby pobrać.",
                "AVAILABLE": "dostępny",
                "DISCONNECTED": "niepowiązany",
                "DELETED": "usunięty",
                "EXPIRED": "wygasły",
                "WAITING": "Czekanie",
                "FAILED": "przegrany"
            },
            "AUTHENTICATE": {
                "MESSAGE": "Wystąpił błąd."
            },
            "AD_LOGIN": {
                "MESSAGE": "Wystąpił błąd."
            },
            "AD_ERROR": {
                "ACCOUNT_NOT_FOUND": "Twoje konto nie jest podłączone do Azure AD.",
                "PERMISSION_DENIED": "Nie masz uprawnień, aby zobaczyć tę stronę.",
                "INTERNAL_ERROR": "Wystąpił błąd.",
                "CONTACT_MAIL": "Skontaktuj się z <strong> {{ contactMail }} </ strong>."
            }
        },
        "TUTORIALS": {
            "TUTORIAL_LINK": "Pokaż samouczek użytkownika.",
            "NEXT": "Następny",
            "END": "Kończyć się",
            "MIC_CAMERA": "Otwórz / zamknij mikrofon lub kamera",
            "END_CALL": "Zostaw sesję.",
            "RECORD": "Rozpocznij / przestań nagrywanie całą sesję",
            "SCREEN_SHARING": "Uruchom / zatrzymaj udostępnianie ekranu, aby pokazać innym użytkownikom, co robisz",
            "REACTION": "Wyślij reakcję na wszystkich, szczególnie przydatnych, gdy jakość audio jest słaba, np. W głośnym otoczeniu",
            "OPEN_AR_PLUS": "Otwarty AR +.",
            "DRAW_ON_SURFACE": "Rysuj na trybie AR + na powierzchni podświetlonej z niebieską siatką",
            "OPEN_AR": "Otwarty ar.",
            "HOLD_TO_HIGHLIGHT": "Kliknij i przytrzymaj, aby podświetlić określone obszary na żywo strumienia z AR",
            "TAKE_SNAPSHOT": "Wykonaj wysoką jakość obrazu za pomocą aparatu innego użytkownika",
            "NO_CAMERA": "Aparat z drugiej musi być włączony, a dostęp musi być włączony",
            "WAIT_OR_SKIP": "Poczekaj, aż inny użytkownik przetestował tę funkcję lub pomiń tę funkcję",
            "COLLABORATE": "Współpracuj na Snapshot: Szkicuj i umieść diagramy, specjalne kształty lub teksty",
            "OPEN_ANNOTATION": "Otwarta adnotacja.",
            "SKETCH_ON_COLL": "Szkic na okienku współpracy",
            "END_TUTORIAL": "Możesz uzyskać dostęp do tego samouczka w dowolnym momencie",
            "USER_TUTORIAL": "Samouczek użytkownika",
            "GUIDE": "Ten samouczek użytkownika poprowadzi Cię krok po kroku przez platformę",
            "DONT_SHOW": "Nie pokazuj ponownie",
            "SKIP_TUTORIAL": "Pomiń tutorial",
            "CANCEL": "Zatrzymać",
            "SKIP": "Pomijać",
            "ASK_AGAIN": "Czy na pewno chcesz pominąć ten samouczek?"
        },
        "NOT_FOUND": {
            "PAGE_NOT_FOUND": "Przykro nam, której żądana strona nie można znaleźć.",
            "NO_LONGER_AVAILABLE": "URL może być napisany lub strona, której szukasz, nie jest już dostępny."
        },
        "DOWNLOADS": {
            "FILE_NOT_FOUND": "Nie znaleziono pliku",
            "IF_DOWNLOAD_NOT_STARTED": "Jeśli pobieranie się nie rozpoczęło, ",
            "CLICK_HERE": "kliknij tutaj"
        },
    "PAGINATOR": {
        "ITEMS_PER_PAGE": "Elementów na stronie:",
        "NEXT_PAGE": "Następna strona",
        "PREVIOUS_PAGE": "Poprzednia strona",
        "FIRST_PAGE": "Pierwsza strona",
        "LAST_PAGE": "Ostatnia strona",
        "RANGE": "{{start}} – {{end}} z {{length}}",
        "RANGE_ZERO": "0 z {{length}}"
    }
}